import { OnInit, Component } from '@angular/core';
import { ImageUpdateService } from '../catalogue/image-update/image-update.service';
import { ToasterService } from 'angular2-toaster';

@Component({
    templateUrl: 'statistics.component.html',
    styleUrls: ['statistics.component.scss']
})
export class StatisticsComponent implements OnInit {

    private imageUpdateLoading = false;
    private stateCounts;
    private users = [];
    private userStateCounts;

    // Date variables
    private maxDate = new Date();
    private startDate = new Date('2019-01-01');
    private endDate = new Date();

    constructor(private imageUpdateService: ImageUpdateService,
        private toasterService: ToasterService){}

    ngOnInit() {}

    handleSearch() {
        this.imageUpdateLoading = true;
        this.stateCounts = undefined;
        this.userStateCounts = undefined;
        this.users = [];
        // Make the call to get image update statistics
        this.imageUpdateService.getCount(this.startDate, this.endDate)
        .then((res) => {
            this.imageUpdateLoading = false;
            this.stateCounts = res.stateCounts.reduce((result, item) => {
                result[item[0]] = item[1];
                return result;
            }, {});
            this.userStateCounts = res.userStateCounts.reduce((result, item) => {
                if (result[item[0]]) {
                    result[item[0]][item[1]] = item[2];
                } else {
                    this.users.push(item[0]);
                    result[item[0]] = {};
                    result[item[0]][item[1]] = item[2];
                }
                return result;
            }, {});
        })
        .catch((err) => {
            this.imageUpdateLoading = false;
            this.handleError('Failed to get statistics for image updates', err);
        });
    }

    handleError(message: string, error: any) {
        console.error(`${message}: ${error.toString()}`);
        this.toasterService.pop('error', message);
    }
}


// WEBPACK FOOTER //
// ./src/app/statistics/statistics.component.ts